const styles = () => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    margin: '0 auto',
    padding: '20px 30px 30px',
    boxSizing: 'border-box',
    width: '100%',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    padding: '24px',
    textAlign: 'center',
  },
});

export default styles;
